import BotInterface from "./BotInterface";
export default function Clinician() {
  return <BotInterface botType="clinician" />;
}
